import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { switchMap, catchError, tap } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { AbstractEffects } from '../../abstract.effects';
import { UpdateSelectedProcedure } from '../actions/selected-procedure.actions';
import { LandlineMissionService } from '../../services/landline-mission.service';
import {
    ELandlineMissionActions,
    SaveLandlineMission,
    SaveLandlineMissionSuccess,
    UpdateLandlineMission
} from '../actions/landline-mission.actions';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { LandLineListInterfaceState } from '../../../landlines/store/state/land-line-list.state';
import { SelectedLandLineInterfaceState } from '../../../landlines/store/state/selected-land-line.state';

@Injectable()
export class LandlineMissionEffects extends AbstractEffects {

  constructor(
    private landlineMissionService: LandlineMissionService,
    private actions: Actions,
    public override store: Store<any>
  ) {
    super(store);
  }

  procedureCode: string;
  payload: any;

    updateLandlineMission = createEffect(() => this.actions.pipe(
        ofType<UpdateLandlineMission>(ELandlineMissionActions.UpdateLandlineMission),
        tap(params => {
            this.payload = params.payload;
            this.procedureCode = params.procedureCode;
        }),
        switchMap(() => this.landlineMissionService.update(this.payload, this.procedureCode)),
        switchMap((response: any) => of(new SaveLandlineMissionSuccess(response))),
        tap( () => {
            this.store.dispatch(new UpdateSelectedProcedure(''));
            this.DisplayMessage(this.procedureCode, 200, new UpdateSelectedProcedure(''), this.payload);
        }),
        catchError((error) => {
            this.DisplayMessage('error_with_retry', 400);
            return throwError(error);
        })
    ));

    saveLandlineMission = createEffect(() => this.actions.pipe(
        ofType<SaveLandlineMission>(ELandlineMissionActions.SaveLandlineMission),
        tap(params => {
            this.payload = params.payload;
            this.procedureCode = params.procedureCode;
        }),
        switchMap(() => this.landlineMissionService.save(this.payload, this.procedureCode)),
        switchMap((response: any) => of(new SaveLandlineMissionSuccess(response))),
        tap( () => {
            this.updateSate(this.procedureCode, this.payload);
            this.DisplayMessage(this.procedureCode, 200, new UpdateSelectedProcedure(''), this.payload);
        }),
        catchError((error) => {
            this.DisplayMessage('error_with_retry', 400);
            return throwError(error);
        })
    ));

    private updateSate(procedureCode: string, object: any) {
        if (procedureCode === ConstsHelper.PROCEDURE_IDENTIFY_LANDLINE) {
            this.store.pipe(select(ConstsHelper.REDUCER_LAND_LINES_LIST)).subscribe((response: LandLineListInterfaceState) => {
                for (const customerLandLine of response.list) {
                    if (customerLandLine.phoneNumber === object.landline) {
                        customerLandLine.comment = object.newName;
                        break;
                    }
                }
            });
            // update description selected line
            this.store.pipe(select(ConstsHelper.REDUCER_LAND_LINE)).subscribe((response: SelectedLandLineInterfaceState) => {
                if (response.line.phoneNumber === object.phoneNumber) {
                    if (procedureCode === ConstsHelper.PROCEDURE_IDENTIFY_LANDLINE) {
                        response.line.comment = object.newName;
                    }
                }
            });
        }
    }
}
